/** @format */

import "assets/style/globals.css";
import "react-medium-image-zoom/dist/styles.css";
import "react-toastify/dist/ReactToastify.css";
import "react-quill-new/dist/quill.snow.css";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

import React from "react";
import App from "App";
import ReactDOM from "react-dom/client";
import { ToastContainer } from "react-toastify";
import { I18nextProvider } from "react-i18next";

import "gantt-task-react/dist/index.css";
import { SnackbarProvider } from "notistack";
import { SnackbarUtilsConfigurator } from "utils";
import i18n from "i18n";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { UserProvider } from "contexts";
import { ThemeProvider } from "contexts/ThemeContext";
import { AppWrapper } from "components/common/PageMeta";
import {
  AllCommunityModule,
  ModuleRegistry,
  provideGlobalGridOptions,
} from "ag-grid-community";

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
provideGlobalGridOptions({
  theme: "legacy",
});
ModuleRegistry.registerModules([AllCommunityModule]);

root.render(
  <QueryClientProvider client={queryClient}>
    <UserProvider>
      <I18nextProvider i18n={i18n}>
        <ToastContainer />
        <SnackbarProvider
          classes={{ containerRoot: "toast-container" }}
          maxSnack={3}
          anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        >
          <BrowserRouter>
            <ThemeProvider>
              <AppWrapper>
                <App />
              </AppWrapper>
            </ThemeProvider>
          </BrowserRouter>
          <SnackbarUtilsConfigurator />
        </SnackbarProvider>
      </I18nextProvider>
    </UserProvider>
  </QueryClientProvider>
);
